import actions from './actions';

const {
  LIST_APP_CONFIGS_BEGIN,
  LIST_APP_CONFIGS_SUCCESS,
  LIST_APP_CONFIGS_ERR,
  UPDATE_APP_CONFIG_BEGIN,
  UPDATE_APP_CONFIG_SUCCESS,
  UPDATE_APP_CONFIG_ERR,
  ENABLE_APP_CONFIG_BEGIN,
  ENABLE_APP_CONFIG_SUCCESS,
  ENABLE_APP_CONFIG_ERR,
  DISABLE_APP_CONFIG_BEGIN,
  DISABLE_APP_CONFIG_SUCCESS,
  DISABLE_APP_CONFIG_ERR,
} = actions;

const initState = {
  appConfigs: [],
  loadingListAppConfigs: false,
  errorListAppConfigs: null,
  loadingUpdateAppConfig: false,
  errorUpdateAppConfig: false,

  loadingDeleteAppConfig: false,
  errorDeleteAppConfig: null,

  loadingEnableAppConfig: false,
  errorEnableAppConfig: null,

  loadingDisableAppConfig: false,
  errorDisableAppConfig: null,
};

const appConfigsReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_APP_CONFIGS_BEGIN:
      return {
        ...state,
        loadingListAppConfigs: true,
        errorListAppConfigs: null,
      };
    case LIST_APP_CONFIGS_SUCCESS:
      console.log('Merchant Groups list::: ', data);
      return {
        ...state,
        appConfigs: [...data],
        loadingListAppConfigs: false,
        errorListAppConfigs: null,
      };
    case LIST_APP_CONFIGS_ERR:
      return {
        ...state,
        errorListAppConfigs: err,
        loadingListAppConfigs: false,
      };

    case UPDATE_APP_CONFIG_BEGIN:
      return {
        ...state,
        loadingUpdateAppConfig: true,
        errorUpdateAppConfig: null,
      };
    case UPDATE_APP_CONFIG_SUCCESS:
      console.log('Updated Merchant Groups  ::: ', data);

      // eslint-disable-next-line no-case-declarations
      const updatedList = state.appConfigs.map((item) => (item.APP_CONFIG_id === data.APP_CONFIG_id ? data : item));
      return {
        ...state,
        appConfigs: [...updatedList],
        loadingUpdateAppConfig: false,
        errorUpdateAppConfig: null,
      };
    case UPDATE_APP_CONFIG_ERR:
      return {
        ...state,
        errorUpdateAppConfig: err,
        loadingUpdateAppConfig: false,
      };

    case ENABLE_APP_CONFIG_BEGIN:
      return {
        ...state,
        loadingEnableAppConfig: true,
        errorEnableAppConfig: null,
      };
    case ENABLE_APP_CONFIG_SUCCESS:
      return {
        ...state,
        loadingEnableAppConfig: false,
        errorEnableAppConfig: null,
      };
    case ENABLE_APP_CONFIG_ERR:
      return {
        ...state,
        errorEnableAppConfig: err,
        loadingEnableAppConfig: false,
      };

    case DISABLE_APP_CONFIG_BEGIN:
      return {
        ...state,
        loadingDisableAppConfig: true,
        errorDisableAppConfig: null,
      };
    case DISABLE_APP_CONFIG_SUCCESS:
      return {
        ...state,
        loadingDisableAppConfig: false,
        errorDisableAppConfig: null,
      };
    case DISABLE_APP_CONFIG_ERR:
      return {
        ...state,
        errorDisableAppConfig: err,
        loadingDisableAppConfig: false,
      };

    default:
      return state;
  }
};

export { appConfigsReducer };
